<template>
    <div class="center w-full pl-0 pr-0 xl:pl-4 xl:pr-4 lg:pl-3 lg:pr-3">
		<div class="flex w-full justify-content-center align-items-center pt-0 pb-0 xl:pt-4 xl:pb-8 lg:pt-3 lg:pb-5">
			<div class="flex flex-column w-full pt-4 pl-3 pr-3 pb-4 xl:p-6 lg:p-5 md:p-4 xl:border-round-xl lg:border-round-xl">
                <span class="flex text-900 font-medium mb-4 xl:mb-6 text-3xl xl:text-6xl lg:text-5xl md:text-4xl justify-content-center">
                    {{ content[lang].title }}
                </span>
                
                <span class="text-lg line-height-2">
                    {{ content[lang].text1 }}
                </span>
                <img src="/images/svg/icons/howitwork_steps.jpg" class="w-full my-4 block">
                <br><br>
                <span class="text-2xl font-medium line-height-1">
                    {{ content[lang].title2 }}
                </span>
                <br><br>
                <span class="text-lg line-height-2">
                    {{ content[lang].text2 }}
                </span>
                <img src="/images/svg/icons/howitwork_scheme.jpg" class="w-full my-4 block">

                <span class="text-2xl font-medium line-height-1">
                    {{ content[lang].title3 }}
                </span>
                <br><br>
                <span class="text-lg line-height-2">
                    {{ content[lang].text3 }}
                </span>
                <span class="text-lg line-height-2">
                    <ol>
                        <li for="list" v-for="(item, index) in content[lang].list" :key="index" class="mb-3">{{ item }}</li>
                    </ol>
                </span>
                <br><br>

                <span class="text-2xl font-medium line-height-1">
                    {{ content[lang].title4 }}
                </span>
                <br><br>
                <span class="text-lg line-height-2">
                    {{ content[lang].text4 }}
                </span>
			</div>
		</div>
	</div>

</template>

<script>
export default {
    name: 'CashPage',
    data() {
        return {
            content: {
                ru: {
                    title: 'Как работают онлайн-переводы',
                    text1: 'PayWave работает по модели трех сторон - отправитель, получатель и сервис. Где сервис (мы) выступаем гарантом того, что средства будут гарантировано доставлены получателю, если отправитель их отправит.',
                    title2: 'Как происходит процесс перевода?',
                    text2: 'Первым шагом Отправитель создает Трансфер на сайте, где Трансфер – это просто виртуальная запись в базе данных, в которой указываются реквизиты Отправителя и Получателя. Далее, в качестве оплаты, Отправитель отправляет средства на карту Доверенного лица сервиса PayWave. Доверенное лицо – это верифицированный пользователь сервиса имеющий банковскую карту, к примеру, российскую или местную (индонезийскую). Таким образом средства не выходят за рамки страны (России, к примеру), чем не нарушаются санкции и ограничения введенные Visa и Mastercard. Третьим шагом, если средства поступили в полной мере и на верную карту, сервис в лице другого Доверенного лица отправляет деньги получателю, уведомляет отправителя по почте и на сайте, и отмечает Трансфер как выполненный.',
                    title3: 'Чем мы лучше Бинанс (криптобирж)?',
                    text3: 'Не секрет, что наша модель схожа с P2P на Бинанс и других криптовалютных бирж, но есть несколько отличий:',
                    list: [
                        'С нами просто: клиентам сервиса PayWave не нужно покупать и продавать криптовалюты, а также разбираться в сложностях ее работы.',
                        'Быстро: перевод в PayWave в отличие от обмена на P2P проходит в разы быстрее, в среднем 5 минут.',
                        'Безопасно: наши Доверенные лица имеют страховые депозиты. И в случае ошибки допущенной Доверенным лицом – мы гарантировано исполним ваш перевод.',
                        'Анонимно: мы не просим верификацию по паспорту и точно не блокируем по национальному признаку.',
                        'Удобно: мы принимаем и отправляем переводы третьим лицам, в том случае, если вы хотите отправить средства не себе “с карты на карту“, а другому человеку.'
                    ],
                    title4: 'Безопасно ли это?',
                    text4: 'Ваши переводы полностью безопасны, потому что не уходят за рамки страны, более того, мы стараемся принять средства в рамках одного банка, чтобы деньги моментально зачислялись и всегда можно было легко их отследить. Что касается данных – мы не храним данные ваших банковских карт или счетов, которые могут быть скомпрометированы и использованы против вас. Мы надежно храним данные Тренсферов в зашифрованном виде, а именно – имя Получателя и Отправителя, а так же номер счета или номер карты Получателя. Этой информации не достаточно, чтобы взломать ваш банк или карту. Единственный и самый важный момент – нужно отправлять средства строго по реквизитам Доверенного лица, которые высвечиваются на нашем сайте, иначе, в случае вашей ошибки – вернуть средства будет сложно.',
				},
				en: {
                    title: 'How online transfers work',
                    text1: 'PayWave operates on a three-party model - sender, recipient, and service. Where the service (we) act as a guarantor that the funds will be guaranteed delivered to the recipient if the sender sends them.',
                    title2: 'How does the transfer process work?',
                    text2: 'The Sender creates a Transfer on the site, where the Transfer is just a virtual record in the database that specifies the details of the Sender and Recipient. Next, as payment, the Sender sends funds to the card of the Trusted person of the PayWave service. A Trusted person is a verified user of the service who has a bank card, for example, Russian or local (Indonesian). Thus, the funds do not leave the country (Russia, for example), so Visa and Mastercard sanctions and restrictions are not violated. The third step, if the funds have been received in full and to the correct card, the service in the person of another Trusted person sends the money to the recipient, notifies the sender by mail and on the site, and marks the Transfer as completed.',
                    title3: 'How are we better than Binance (cryptocurrency exchanges)?',
                    text3: 'It is no secret that our model is similar to P2P on Binance and other cryptocurrency exchanges, but there are several differences:',
                    list: [
                        'With us it is simple: PayWave service clients do not need to buy and sell cryptocurrencies, as well as understand the complexities of its operation.',
                        'Quickly: a transfer to PayWave, unlike an exchange on P2P, takes place several times faster, on average 5 minutes.',
                        'Safely: our Trusted persons have insurance deposits. And in case of an error made by a Trusted person, we will guarantee the execution of your transfer.',
                        'Anonymously: we do not ask for verification by passport and certainly do not block by national sign.',
                        'Conveniently: we accept and send transfers to third parties, in case you want to send funds not to yourself “from card to card”, but to another person.'
                    ],
                    title4: 'Is it safe?',
                    text4: 'Your transfers are completely safe because they do not leave the country, moreover, we try to accept funds within the same bank so that the money is credited instantly and can always be easily tracked. As for the data - we do not store data of your bank cards or accounts that can be compromised and used against you. We securely store the data of the Transfers in encrypted form, namely - the name of the Recipient and Sender, as well as the account number or card number of the Recipient. This information is not enough to hack your bank or card. The only and most important point is to send funds strictly to the details of the Trusted person, which are displayed on our site, otherwise, in case of your mistake - it will be difficult to return the funds.',
				}
			},
        }
    },
    computed: {
        lang() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        }
    },
    methods: {
        goCreate(){
            this.$router.push({
                path: '/personal/transfer/create/'
            })
        },
    },
    beforeCreate() {

    },
}
</script>